import React from "react"
import { Box } from "@mallardbay/lib-react-components"

import { TextXLargeBold } from "~components/shared/todo-lib-react-components/text"
import FilterCheckbox from "~components/pages/search/search-filters/filter-checkbox"
import { useSharedStyles } from "~components/pages/search/search-filters/use-shared-styles"
import COPY from "~config/copy-constants"

interface Props {
    readonly hasIncludedLodging: true | undefined
    readonly setHasIncludedLodging: (hasIncluded: true | undefined) => void
}

export default function LodgingFilter({
    hasIncludedLodging,
    setHasIncludedLodging,
}: Props) {
    const sharedStyles = useSharedStyles({ shouldAddBottomPadding: true })

    return (
        <Box style={sharedStyles.wrapper}>
            <TextXLargeBold>{COPY.LODGING}</TextXLargeBold>
            <FilterCheckbox
                label={COPY.INCLUDES_LODGING}
                isChecked={Boolean(hasIncludedLodging)}
                onChange={(isSelected: boolean) =>
                    setHasIncludedLodging(isSelected || undefined)
                }
            />
        </Box>
    )
}
